import {
  classifyBp, BP_CLASS_TIER, BP_CLASS_DETAIL, BP_CLASS_LABELS,
} from '../logic/bpReadings';

interface BpValueProps {
  systolic?: number | null;
  diastolic?: number | null;
  /** Shown when there is no reading. */
  empty?: string;
  /** False where a column header already says "mmHg". */
  unit?: boolean;
  className?: string;
}

const cx = (...parts: (string | false | undefined)[]) => parts.filter(Boolean).join(' ');

// The hue rides a dot (the --wi-status-* fills fail contrast as text); the class name is the dot's text twin.
export default function BpValue({
  systolic, diastolic, empty = '—', unit = true, className,
}: BpValueProps) {
  if (systolic == null) return <span className={cx('bp-value is-empty', className)}>{empty}</span>;
  const cls = classifyBp(systolic, diastolic);
  const tier1 = BP_CLASS_TIER[cls] === 1;
  const value = `${tier1 ? '⚠ ' : ''}${systolic}${diastolic != null ? `/${diastolic}` : ''}`;
  return (
    <span className={cx('bp-value', tier1 && 'is-tier1', className)} title={BP_CLASS_DETAIL[cls]}>
      <span className={`bp-value__dot bp-value__dot--${cls}`} aria-hidden="true" />
      <span className="bp-value__num">{value}</span>
      {unit ? <span className="bp-value__unit">mmHg</span> : <span className="sr-only">mmHg</span>}
      <span className="sr-only">{BP_CLASS_LABELS[cls]}</span>
    </span>
  );
}
